<script>
export default {
   name: 'Avatar',
   props: {
      src: {
         type: String,
         required: false
      },
      text: {
         type: String,
         required: false,
         default: 'Avatar'
      },
      alt: {
         type: String,
         required: true
      },
      size: {
         type: Number,
         default: 50
      }
   },
   computed: {
      getInitials() {
         const text = this.text.trim() || ''
         return text
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase())
            .join('')
            .slice(0, 2)
      }
   }
}
</script>

<template>
   <div :style="{ width: `${size}px`, height: `${size}px` }" class="avatar">
      <img v-if="src" :alt="alt" :src="src" class="avatar__img" />
      <div v-else class="avatar__text">{{ getInitials }}</div>
   </div>
</template>

<style lang="scss" scoped>
.avatar {
   display: inline-flex;
   align-items: center;
   justify-content: center;
   background: linear-gradient(24deg, #ed5c19, #fc9a03);
   border-radius: 50%;
   border: 1px solid var(--bs-white);
   overflow: hidden;

   &__img {
      width: 100%;
      height: 100%;
      object-fit: cover;
   }

   &__text {
      font-size: 26px;
      font-weight: bold;
      color: var(--bs-white);
      display: flex;
      align-items: center;
      justify-content: center;
   }
}
</style>
